import React from 'react'
import PropTypes from 'prop-types'

import { SERVICE_LABEL_INVESTOR } from '../Helper/constants.js'

function NoSubscriptions({ handleSubscribe, userSubscriptionProfile }) {
  return (
    <React.Fragment>
      <hr className="Rule u-textColorBrand" />
      <div
        id="Your-subscriptions"
        className="Card Grid u-lg-sizeConstrained u-marginBottom4gu u-bgColorWhite u-sm-paddingHoriz3gu u-sm-paddingVert6gu"
      >
        <div className="Grid u-sizeFull u-marginBottom3gu">
          <div className="u-flex">
            <h2 className="u-flexGrow1">Your subscriptions (0)</h2>
            <button
              className="Button Button--tertiary u-paddingHoriz0 u-textSecondary u-textNoTransform u-textKernDefault"
              data-tracking="secondary"
              disabled
            >
              Unsubscribe from Selected Communications
            </button>
          </div>
        </div>
        <div className="u-sizeFull">
          <p className="u-padding8gu u-marginBottom5gu u-bgColorLight u-textCenter">
            You do not have any elected subscriptions.
          </p>
          <h3 className="u-sizeFull u-marginBottom6gu">Most Popular</h3>
          <div className="Grid u-marginBottom3gu">
            <div className="u-size4of12 u-paddingHoriz4gu u-sm-sizeFull u-sm-marginBottom6gu u-textCenter">
              <h4 className="u-marginBottom2gu">Latest Insights</h4>
              <p className="u-marginBottom2gu">
                Hear from our thought leaders on global market and economic
                events.
              </p>
              <button
                onClick={handleSubscribe}
                data-checked={true}
                value="6bc1b266d5a146ad236481c964587e48"
                className="Button Button--primary u-paddingHoriz6gu u-paddingVert2gu u-marginBottom1gu"
                data-analytics="cesc-popular-subscribe"
              >
                Subscribe
              </button>
            </div>
            <div className="u-size4of12 u-paddingHoriz4gu u-sm-sizeFull u-sm-marginBottom6gu u-borderColorNeutralLight u-borderBottom0 u-borderTop0 u-borderLeft u-borderRight u-sm-u-border0 u-textCenter">
              <h4 className="u-marginBottom2gu">Market Volatility</h4>
              <p className="u-marginBottom2gu">
                Get real-time alerts on all things related to market volatility.
              </p>
              <button
                onClick={handleSubscribe}
                data-checked={true}
                value="c1a5252cdd726c24bbd2bed41e56d173"
                className="Button Button--primary u-paddingHoriz6gu u-paddingVert2gu u-marginBottom1gu"
                data-analytics="cesc-popular-subscribe"
              >
                Subscribe
              </button>
            </div>
            <div className="u-size4of12 u-paddingHoriz4gu u-sm-sizeFull u-textCenter">
              {userSubscriptionProfile.role === SERVICE_LABEL_INVESTOR ? (
                <>
                  <h4 className="u-marginBottom2gu">Investor Newsletter</h4>
                  <p className="u-marginBottom2gu">
                    Follow current economic trends, investment themes and
                    products.
                  </p>
                  <button
                    onClick={handleSubscribe}
                    data-checked={true}
                    value="c1a5252cdd726c24bbd2bed41e56d173"
                    className="Button Button--primary u-paddingHoriz6gu u-paddingVert2gu u-marginBottom1gu"
                    data-analytics="cesc-popular-subscribe"
                  >
                    Subscribe
                  </button>
                </>
              ) : (
                <>
                  <h4 className="u-marginBottom2gu">Topic: Fixed Income</h4>
                  <p className="u-marginBottom2gu">
                    Get real-time alerts on all things related to fixed income
                  </p>
                  <button
                    onClick={handleSubscribe}
                    data-checked={true}
                    value="185b4ebc3fa7b3db0546b19eb6da83f0"
                    className="Button Button--primary u-paddingHoriz6gu u-paddingVert2gu u-marginBottom1gu"
                    data-analytics="cesc-popular-subscribe"
                  >
                    Subscribe
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

NoSubscriptions.propTypes = {
  handleSubscribe: PropTypes.func.isRequired,
}

export default NoSubscriptions
